import { render } from "./SudokuBoard.vue?vue&type=template&id=c81bdd64&scoped=true"
import script from "./SudokuBoard.vue?vue&type=script&lang=js"
export * from "./SudokuBoard.vue?vue&type=script&lang=js"

import "./SudokuBoard.vue?vue&type=style&index=0&id=c81bdd64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c81bdd64"]])

export default __exports__